/*jshint esversion: 6 */
jQuery(document).ready(function($) {

    $(".carouselThumbnailContainer").each(function() {

        let sync1 = $(this).find(".carouselOne");
        let sync2 = $(this).find(".carouselTwo");
        let carouselOneSlides = sync1.children();
        let slidesPerPage = sync2.data("slidesPerPage"); // define number of elements per page
        let syncedSecondary = false;

        // console.log("js " + sync1.children.length);

        if (carouselOneSlides.length > 1) {
            sync1.owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                autoplay: false,
                dots: false,
                loop: false,
                responsiveRefreshRate: 200,
                navText: [`<svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 8 8"><path d="M4 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z" transform="translate(1)" fill="#333" /></svg>`, `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 8 8"><path d="M1.5 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z" transform="translate(1)" fill="#333" /></svg>`],
            }).on("changed.owl.carousel", syncPosition);

            sync2.on("initialized.owl.carousel", function() {
                sync2.find(".owl-item").eq(0).addClass("current");
            }).owlCarousel({
                items: slidesPerPage,
                dots: false,
                loop: false,
                nav: false,
                smartSpeed: 200,
                slideSpeed: 500,
                slideBy: 1,
                responsiveRefreshRate: 100
            }).on("changed.owl.carousel", syncPosition2);

        } else {
            sync1.show();
        }

        function syncPosition(el) {

            let onscreen = sync2.find(".owl-item.active").length - 1;
            let start = sync2.find(".owl-item.active").first().index();
            let end = sync2.find(".owl-item.active").last().index();

            //if you set loop to false, you have to restore this next line
            let current = el.item.index;

            //if you disable loop you have to comment this block
            // let count = el.item.count - 1;
            // let current = Math.round(el.item.index - (el.item.count / 2) - 0.5);
            //
            // if (current < 0) {
            //     current = count;
            // }
            // if (current > count) {
            //     current = 0;
            // }

            //end block

            sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");

            if (current > end) {
                sync2.data("owl.carousel").to(current, 100, true);
            }
            if (current < start) {
                sync2.data("owl.carousel").to(current - onscreen, 100, true);
            }
        }

        function syncPosition2(el) {
            if (syncedSecondary) {
                let number = el.item.index;
                sync1.data("owl.carousel").to(number, 100, true);
            }
        }

        sync2.on("click", ".owl-item", function(e) {
            e.preventDefault();
            let number = $(this).index();
            sync1.data("owl.carousel").to(number, 300, true);
        });
    });

    jQuery(".carouselIntroSlider").owlCarousel({
        items: 1,
        nav: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 7000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
    });

    jQuery(".carouselHeroSlider").owlCarousel({
        items: 1,
        nav: false,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 7000
    });

});